import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $moviesTitles = combine(i18n.$t, ({ t }) => ({
  detailsButtonTitle: t('details'),
  playButtonTitle: t('play'),
  unlockButtonTitle: t('button_unlock'),
  bannerIsLockedMessage: t('locked_popup_hint'),
}))
